<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <beef-cattle-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></beef-cattle-form>
  </j-modal>
</template>

<script>

  import BeefCattleForm from './BeefCattleCalfForm'

  export default {
    name: 'BeefCattleCalfModal',
    components: {
      BeefCattleForm
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      setBeefNumber(beefNumber) {
        this.$nextTick(() => {
          this.$refs.realForm.setBeefNumber(beefNumber)
          this.disableSubmit = false
        })
      },
      add() {
        this.visible = true
        this.disableSubmit = false
        this.$nextTick(() => {
          this.$refs.realForm.add()
        })
      },
      edit(record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record)
        })
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        this.$refs.realForm.submitForm()
      },
      submitCallback() {
        this.$emit('ok')
        this.visible = false
      },
      handleCancel() {
        this.close()
      }
    }
  }
</script>